/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationSharedSubStatusReasonList200,
  GetApiV1CourseregistrationSharedSubStatusReasonList401,
  GetApiV1CourseregistrationSharedSubStatusReasonList500,
  GetApiV1CourseregistrationSharedSubStatusReasonListQueryParams,
  GetApiV1CourseregistrationSharedSubStatusReasonListQueryResponse,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedSubStatusReasonList.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1CourseregistrationSharedSubStatusReasonListQueryParamsSchema =
  z
    .object({
      statusReasonId: z.optional(z.coerce.number().int()),
    })
    .optional() as unknown as ToZod<GetApiV1CourseregistrationSharedSubStatusReasonListQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationSharedSubStatusReasonList200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedSubStatusReasonList200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationSharedSubStatusReasonList401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedSubStatusReasonList401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationSharedSubStatusReasonList500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationSharedSubStatusReasonList500>;

export const getApiV1CourseregistrationSharedSubStatusReasonListQueryResponseSchema =
  z.lazy(
    () => getApiV1CourseregistrationSharedSubStatusReasonList200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationSharedSubStatusReasonListQueryResponse>;
